import request from '@/utils/request'

export function getWxRecharge(url, appid, amount) {
  return request({
    url: url + appid,
    method: 'get',
    params: { amount }
  })
}
